export enum ECustomerType {
  LiteUser = 0,
  VerifiedUser = 1,
}